export const newsList = [
  {
    id: "n1",
    title: "「璃月远征」版本 5.0 前瞻直播内容汇总，全新地区与角色首曝",
    excerpt: "官方前瞻特别节目公开了新地区地形、双五星角色技能演示以及版本活动日历，本文为你整理全部重点信息。",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20fantasy%20floating%20islands%20with%20crystal%20spires%20and%20misty%20cliffs%2C%20cinematic%20teal%20and%20gold%20color%20palette%2C%20epic%20adventure%20concept%20art%2C%20soft%20painterly%20style&width=800&height=500&seq=news-cover-01&orientation=landscape",
    date: "2026-10-10",
    type: "news",
    category: "版本前瞻",
    tags: ["版本前瞻", "新角色", "新地区"],
    author: "提瓦特情报组",
    readTime: "6 分钟",
    featured: true,
  },
  {
    id: "n2",
    title: "深境螺旋第十二层阵容推荐：本期环境最强四套配队解析",
    excerpt: "本期深渊祝福偏向元素反应增伤，我们测试了十二套主流阵容，为你筛选出通过率最高的四套。",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20glowing%20elemental%20crystals%20surrounding%20an%20ornate%20stone%20arena%2C%20deep%20blue%20and%20amber%20light%2C%20mystical%20chamber%20concept%20art%2C%20painterly%20fantasy%20style&width=800&height=500&seq=news-cover-02&orientation=landscape",
    date: "2026-10-08",
    type: "news",
    category: "攻略精选",
    tags: ["深渊", "阵容搭配", "战斗攻略"],
    author: "深渊研究社",
    readTime: "8 分钟",
    featured: false,
  },
  {
    id: "n3",
    title: "【公告】10月11日全服停机维护完成，补偿原石已发放",
    excerpt: "本次维护修复了部分角色技能异常与联机延迟问题，补偿奖励已通过邮件发放至冒险等阶 5 以上玩家。",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20calm%20cloud%20sea%20above%20ancient%20ruins%2C%20soft%20cyan%20and%20warm%20orange%20sunlit%20gradient%2C%20serene%20fantasy%20landscape%20concept%20art%2C%20painterly%20style&width=800&height=500&seq=news-cover-03&orientation=landscape",
    date: "2026-10-11",
    type: "announcement",
    category: "维护公告",
    tags: ["公告", "补偿"],
    author: "官方公告",
    readTime: "2 分钟",
    featured: false,
  },
  {
    id: "n4",
    title: "全新角色「雾泽」技能资料公开：水元素单手剑的价值解析",
    excerpt: "从技能倍率到命座收益，本文用实测数据说明「雾泽」在当前版本环境中的定位与抽取建议。",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20elegant%20flowing%20water%20ribbons%20forming%20a%20sword%20shape%2C%20teal%20and%20silver%20luminescence%2C%20mystical%20elemental%20concept%20art%2C%20painterly%20fantasy%20style&width=800&height=500&seq=news-cover-04&orientation=landscape",
    date: "2026-10-05",
    type: "news",
    category: "角色前瞻",
    tags: ["新角色", "水元素", "角色前瞻"],
    author: "角色研究所",
    readTime: "7 分钟",
    featured: true,
  },
  {
    id: "n5",
    title: "限时活动「风花节的回响」玩法详解与速通路线",
    excerpt: "活动共分为三个阶段，本文整理了每日高效刷取路线与隐藏宝箱位置，帮助你在最短时间内拿满奖励。",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20festival%20square%20with%20hanging%20lanterns%20and%20petals%20in%20the%20air%2C%20warm%20amber%20and%20rose%20tones%2C%20cheerful%20fantasy%20town%20concept%20art%2C%20painterly%20style&width=800&height=500&seq=news-cover-05&orientation=landscape",
    date: "2026-10-03",
    type: "event",
    category: "活动攻略",
    tags: ["限时活动", "速通", "奖励"],
    author: "活动攻略组",
    readTime: "5 分钟",
    featured: false,
  },
  {
    id: "n6",
    title: "5.0 版本「元素共鸣」系统调整说明：这些改动影响配队",
    excerpt: "双属性共鸣数值被重新平衡，部分老阵容的输出循环因此发生变化，本文列出了三套需要重新调整的队伍。",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20intertwining%20elemental%20energy%20ribbons%20in%20a%20dark%20starlit%20sky%2C%20violet%20and%20gold%20sparkles%2C%20abstract%20magic%20concept%20art%2C%20painterly%20style&width=800&height=500&seq=news-cover-06&orientation=landscape",
    date: "2026-10-01",
    type: "announcement",
    category: "系统调整",
    tags: ["版本更新", "元素共鸣", "配队"],
    author: "提瓦特情报组",
    readTime: "4 分钟",
    featured: false,
  },
  {
    id: "n7",
    title: "圣遗物词条收益速查表：攻击沙漏与元素充能如何取舍",
    excerpt: "我们针对十二位主流主 C 角色计算了不同词条组合的期望伤害，总结出一份可直接套用的配置速查表。",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20ancient%20artifact%20relics%20with%20glowing%20rune%20engravings%2C%20teal%20and%20bronze%20tones%2C%20mystical%20treasure%20concept%20art%2C%20painterly%20fantasy%20style&width=800&height=500&seq=news-cover-07&orientation=landscape",
    date: "2026-09-28",
    type: "news",
    category: "养成攻略",
    tags: ["圣遗物", "词条", "伤害计算"],
    author: "数值研究社",
    readTime: "9 分钟",
    featured: false,
  },
  {
    id: "n8",
    title: "新玩家入坑指南：前期资源分配与主线节奏规划",
    excerpt: "刚入坑不知道先做什么？这份路线图帮你在一周内完成主线、解锁关键系统并攒够第一发十连。",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20young%20adventurer%20silhouette%20looking%20at%20a%20distant%20luminous%20mountain%2C%20golden%20hour%20lighting%20with%20soft%20cyan%20highlights%2C%20hopeful%20fantasy%20concept%20art%2C%20painterly%20style&width=800&height=500&seq=news-cover-08&orientation=landscape",
    date: "2026-09-25",
    type: "news",
    category: "新手入门",
    tags: ["新手", "资源规划", "主线"],
    author: "新手指引组",
    readTime: "10 分钟",
    featured: false,
  },
  {
    id: "n9",
    title: "【公告】账号安全提示：请勿轻信第三方代充与共享账号",
    excerpt: "近期出现冒充官方的钓鱼链接与代充骗局，官方提醒玩家通过正规渠道充值，并开启二次验证。",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20glowing%20shield%20emblem%20floating%20above%20an%20ancient%20gate%2C%20cool%20blue%20and%20silver%20light%2C%20protective%20fantasy%20concept%20art%2C%20painterly%20style&width=800&height=500&seq=news-cover-09&orientation=landscape",
    date: "2026-09-22",
    type: "announcement",
    category: "安全公告",
    tags: ["公告", "账号安全"],
    author: "官方公告",
    readTime: "3 分钟",
    featured: false,
  },
  {
    id: "n10",
    title: "枫丹水下探索全收集：隐藏宝箱与机关解谜图文攻略",
    excerpt: "水下区域地形复杂，本文按区域划分整理了全部隐藏宝箱与机关解法，附详细坐标与路线示意图。",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20underwater%20ruins%20with%20glowing%20coral%20and%20sunbeams%20from%20surface%2C%20aquamarine%20and%20teal%20tones%2C%20serene%20fantasy%20exploration%20concept%20art%2C%20painterly%20style&width=800&height=500&seq=news-cover-10&orientation=landscape",
    date: "2026-09-19",
    type: "news",
    category: "探索攻略",
    tags: ["探索", "宝箱", "解谜"],
    author: "地图探索组",
    readTime: "12 分钟",
    featured: false,
  },
];